import { NavigateFunction } from 'react-router-dom';

import * as Storage from '../storage';
import localforage from 'localforage';

export const logout = async (navigate: NavigateFunction) => {
  Storage.TOKEN.remove();
  Storage.USER_DATA.remove();
  Storage.FILTER_DATA.remove();
  await localforage.removeItem('userData');
  window.history.replaceState(null, '', '/');
  navigate('/login');
};